import "../scss/site.scss";
import * as bootstrap from "bootstrap";

window.bootstrap = bootstrap;

document.querySelectorAll(".filter-btn").forEach((button) => {
  button.addEventListener("click", () => {
    document.querySelectorAll(".filter-btn").forEach((item) => item.classList.remove("active"));
    button.classList.add("active");
    const selected = button.dataset.filter;
    document.querySelectorAll(".product-item").forEach((item) => {
      item.classList.toggle("is-hidden", selected !== "all" && item.dataset.category !== selected);
    });
  });
});

const counterObserver = new IntersectionObserver((entries, observer) => {
  entries.forEach((entry) => {
    if (!entry.isIntersecting) return;
    const element = entry.target;
    const target = Number(element.dataset.count);
    const started = performance.now();
    const tick = (now) => {
      const progress = Math.min((now - started) / 1100, 1);
      element.textContent = Math.floor(target * (1 - Math.pow(1 - progress, 3))).toLocaleString("ko-KR");
      if (progress < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
    observer.unobserve(element);
  });
}, { threshold: 0.5 });

document.querySelectorAll("[data-count]").forEach((counter) => counterObserver.observe(counter));

document.querySelectorAll("#mainNav a").forEach((link) => {
  link.addEventListener("click", () => {
    const menu = document.querySelector("#mainNav");
    if (menu?.classList.contains("show")) bootstrap.Collapse.getOrCreateInstance(menu).hide();
  });
});

document.querySelectorAll("[data-product-search]").forEach((form) => {
  const input = form.querySelector("input[type='search']");
  const cards = [...document.querySelectorAll("[data-product-card]")];
  const empty = document.querySelector("[data-product-empty]");
  const filterProducts = () => {
    const keyword = input.value.trim().toLocaleLowerCase("ko-KR");
    let visibleCount = 0;
    cards.forEach((card) => {
      const visible = !keyword || card.dataset.search.includes(keyword);
      card.hidden = !visible;
      if (visible) visibleCount += 1;
    });
    if (empty) empty.hidden = visibleCount !== 0;
  };
  form.addEventListener("submit", (event) => { event.preventDefault(); filterProducts(); });
  input.addEventListener("input", filterProducts);
});

document.querySelectorAll("[data-specification-search]").forEach((section) => {
  const inputs = [...section.querySelectorAll("[data-specification-field]")];
  const clearButton = section.querySelector("[data-specification-clear]");
  const tableBody = section.querySelector("[data-specification-body]");
  const count = section.querySelector("[data-specification-count]");
  const empty = section.querySelector("[data-specification-empty]");
  let searchTimer;

  const normalize = (value) => String(value ?? "").trim().toLocaleLowerCase("ko-KR");
  const inlineRows = [...tableBody.querySelectorAll("tr")].map((row) => ({
    element: row,
    values: [...row.cells].slice(0, 4).map((cell) => normalize(cell.textContent))
  }));

  const getFilters = () => inputs.map((input) => ({
    key: input.dataset.specificationField,
    value: normalize(input.value)
  }));

  const filterSpecifications = () => {
    const filters = getFilters();
    let visibleCount = 0;
    inlineRows.forEach((row) => {
      const visible = filters.every((filter, index) => !filter.value || row.values[index].includes(filter.value));
      row.element.hidden = !visible;
      if (visible) visibleCount += 1;
    });
    count.textContent = visibleCount.toLocaleString("ko-KR");
    empty.hidden = visibleCount !== 0;
  };

  inputs.forEach((input) => {
    input.addEventListener("input", () => {
      window.clearTimeout(searchTimer);
      searchTimer = window.setTimeout(filterSpecifications, 120);
    });
  });
  clearButton.addEventListener("click", () => {
    inputs.forEach((input) => { input.value = ""; });
    filterSpecifications();
    inputs[0]?.focus();
  });

});

const heroSlides = [...document.querySelectorAll(".hero-slide")];
if (heroSlides.length > 1 && !window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
  let activeHeroSlide = 0;
  window.setInterval(() => {
    heroSlides[activeHeroSlide].classList.remove("active");
    activeHeroSlide = (activeHeroSlide + 1) % heroSlides.length;
    heroSlides[activeHeroSlide].classList.add("active");
  }, 4500);
}
